import React from "react";
import { PortalLegalPage } from "@/components/legal/PortalLegalPage";

export default function ChefLegal() {
  return <PortalLegalPage portal="chef" />;
}
